import type { ComponentProps } from "react";
import { css } from "@stubhub/broadway-foundation/css";
import type { IconButton } from "@stubhub/broadway-web";

export const parentContainer = css({
  backgroundColor: "bg.surface.stronger",
  paddingBlockStart: "primitives.150",
  paddingBlockEnd: "primitives.150",
  display: "flex",
  flexDirection: "column",
  columnGap: "primitives.0",
  rowGap: "primitives.100",
  desktop: {
    paddingInlineStart: "primitives.150",
    paddingInlineEnd: "primitives.150",
    borderStartStartRadius: "primitives.200",
    borderStartEndRadius: "primitives.200",
    borderEndStartRadius: "primitives.200",
    borderEndEndRadius: "primitives.200",
  },
});

export const titleRow = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const titleContent = css({
  display: "flex",
  alignItems: "center",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
  color: "text.subtle",
  marginInlineStart: "primitives.150",
  desktopOnly: {
    marginInlineStart: "primitives.0",
  },
});

export const carouselWrapper = css({
  position: "relative",
  width: "full",
  rowGap: "primitives.100",
  columnGap: "primitives.100",
  display: "flex",
  alignItems: "center",
  tablet: {
    justifyContent: "center",
  },
  desktop: {
    justifyContent: "center",
  },
});

export const carouselScrollContainer = css({
  display: "flex",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
  overflowX: "auto",
  scrollSnapType: "[x mandatory]",
  scrollBehavior: "smooth",
  scrollPaddingInlineStart: "primitives.250",
  width: "full",
  desktopOnly: {
    scrollPaddingInlineStart: "primitives.0",
  },
  WebkitOverflowScrolling: "touch",
  scrollbarWidth: "[none]",
  // Hide scrollbar
  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export const carouselItemRecipe = css({
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: "[calc(50% - 4px)]", // 50% minus half the 8px gap
  minWidth: "[330px]",
  scrollSnapAlign: "start",
  desktop: {
    minWidth: "[324px]",
  },
});

export const carouselSpacer = css({
  flexShrink: 0,
  width: "primitives.0",
});

export const headerIconContainer = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "[24px]",
  height: "[24px]",
  flexShrink: "0",
  backgroundColor: "bg.surface.success",
  borderTopRadius: "primitives.50",
  borderBottomRadius: "primitives.50",
});

export const arrowButtonContainer = css({
  zIndex: "[1]",
});

export const arrowIconButtonClasses: NonNullable<ComponentProps<typeof IconButton>["classes"]> = {
  root: css({
    backgroundColor: "bg",
    boxShadow: "raised",
  }),
};

export const plainParentContainer = css({
  display: "flex",
  flexDirection: "column",
  rowGap: "primitives.100",
  desktop: {
    rowGap: "primitives.200",
  },
});

export const plainTitleContent = css({
  display: "flex",
  alignItems: "center",
  columnGap: "primitives.100",
  color: "text",
});

export const plainCarouselScrollContainer = css({
  display: "flex",
  columnGap: "primitives.150",
  overflowX: "auto",
  scrollSnapType: "[x mandatory]",
  scrollBehavior: "smooth",
  width: "full",
  WebkitOverflowScrolling: "touch",
  scrollbarWidth: "[none]",
  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export const plainCarouselItem = css({
  flexShrink: 0,
  width: "[284px]",
  scrollSnapAlign: "start",
});
